import { FileText } from 'lucide-react'
import { Modal } from '@/components/ui/Modal'
import { Button } from '@/components/ui/Button'

type Props = {
  open: boolean
  submitting?: boolean
  onConfirm: () => void
  onDecline: () => void
  onClose: () => void
}

export function ConvertElaborateProposalConfirmModal({
  open,
  submitting = false,
  onConfirm,
  onDecline,
  onClose,
}: Props) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title='Elaborar proposta agora?'
      description='A negociação será criada em Elaborar Proposta. Você pode montar o plano agora ou depois.'
      size='sm'
      stackPriority='high'
      footer={
        <div className='flex flex-wrap justify-end gap-2'>
          <Button variant='ghost' size='sm' onClick={onDecline} disabled={submitting}>
            Agora não
          </Button>
          <Button
            variant='primary'
            size='sm'
            icon={<FileText size={14} />}
            loading={submitting}
            onClick={onConfirm}
            className='bg-[var(--color-success)] text-white hover:bg-[var(--color-success)] hover:opacity-90'
          >
            Sim, elaborar agora
          </Button>
        </div>
      }
    >
      <p className='text-sm leading-relaxed text-text-secondary'>
        Se escolher <strong className='font-medium text-text-primary'>Sim</strong>, abriremos o editor
        de proposta com planos e itens — igual ao painel da negociação.
      </p>
    </Modal>
  )
}

export default ConvertElaborateProposalConfirmModal
